import regexExps from "@/config/regexExps";

export default function alphaNum(value: string) {
  const regexValue = new RegExp(regexExps.alphaNum);

  return regexValue.test(value);
}
